module.exports = __webpack_public_path__ + "static/img/big_data1.4ba50c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/big_data1.png
// module id = AVls
// module chunks = 0